import i18next from '@packages/core/i18n';

import dashboard from './en/dashboard.json';
import dashboardWidgets from './en/dashboardWidgets.json';
import irPlannerWidget from './en/irPlannerWidget.json';
import loginByCountry from './en/loginByCountry.json';
import loginFailure from './en/loginFailure.json';
import observationPipeline from './en/observationPipeline.json';
import securityPosture from './en/securityPosture.json';

i18next.addResourceBundle('en', 'dashboardLegacy', dashboard);
i18next.addResourceBundle('en', 'dashboardWidgetsLegacy', dashboardWidgets);
i18next.addResourceBundle('en', 'irPlannerWidgetLegacy', irPlannerWidget);
i18next.addResourceBundle('en', 'loginByCountryLegacy', loginByCountry);
i18next.addResourceBundle('en', 'loginFailureLegacy', loginFailure);
i18next.addResourceBundle('en', 'securityPostureLegacy', securityPosture);
i18next.addResourceBundle(
  'en',
  'observationPipelineLegacy',
  observationPipeline,
);
